function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Icon---Info-circle",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 0,
  y: 0,
  width: 24,
  height: 24
}), /*#__PURE__*/React.createElement("path", {
  d: "M12,0 C5.37304839,0 0,5.37498387 0,12 C0,18.6288871 5.37304839,24 12,24 C18.6269516,24 24,18.6288871 24,12 C24,5.37498387 18.6269516,0 12,0 Z M12,5.32258065 C13.1223871,5.32258065 14.0322581,6.23245161 14.0322581,7.35483871 C14.0322581,8.47722581 13.1223871,9.38709677 12,9.38709677 C10.8776129,9.38709677 9.96774194,8.47722581 9.96774194,7.35483871 C9.96774194,6.23245161 10.8776129,5.32258065 12,5.32258065 Z M14.7096774,17.6129032 C14.7096774,17.9335645 14.4496935,18.1935484 14.1290323,18.1935484 L9.87096774,18.1935484 C9.55030645,18.1935484 9.29032258,17.9335645 9.29032258,17.6129032 L9.29032258,16.4516129 C9.29032258,16.1309516 9.55030645,15.8709677 9.87096774,15.8709677 L10.4516129,15.8709677 L10.4516129,12.7741935 L9.87096774,12.7741935 C9.55030645,12.7741935 9.29032258,12.5142097 9.29032258,12.1935484 L9.29032258,11.0322581 C9.29032258,10.7115968 9.55030645,10.4516129 9.87096774,10.4516129 L12.9677419,10.4516129 C13.2884032,10.4516129 13.5483871,10.7115968 13.5483871,11.0322581 L13.5483871,15.8709677 L14.1290323,15.8709677 C14.4496935,15.8709677 14.7096774,16.1309516 14.7096774,16.4516129 L14.7096774,17.6129032 Z",
  id: "Shape",
  fill: "currentColor"
}));

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon - Info circle") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.2571413e.svg";
export { ForwardRef as ReactComponent };